const cellClass = (p, i) => {
  const s = p * i;
  if (s > 15) return "mc-c";
  if (s > 8)  return "mc-h";
  if (s > 4)  return "mc-m";
  return "mc-l";
};

export default function RiskMatrix({ risks }) {
  const ROWS = [5, 4, 3, 2, 1]; // top = high probability
  const COLS = [1, 2, 3, 4, 5];

  const inCell = (p, i) => risks.filter((r) => r.prob === p && r.imp === i);

  return (
    <div className="matrix-panel">
      <div className="matrix-title">Risk Matrix — Probability vs Impact</div>

      <div className="matrix-axis-label" style={{ marginBottom: 6 }}>
        ← Impact →
      </div>

      {/* Row axis label sits to the left */}
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <div
          style={{
            writingMode: "vertical-rl",
            transform: "rotate(180deg)",
            fontSize: 10,
            fontFamily: "var(--fm)",
            color: "var(--muted)",
            letterSpacing: ".05em",
            flexShrink: 0,
          }}
        >
          ← Probability →
        </div>

        <div style={{ flex: 1 }}>
          <div className="matrix-grid">
            {/* Column headers */}
            <div className="m-corner" />
            {COLS.map((c) => (
              <div className="m-col-head" key={c}>{c}</div>
            ))}

            {/* Rows */}
            {ROWS.map((row) => (
              <>
                <div className="m-row-head" key={`rh-${row}`}>{row}</div>
                {COLS.map((col) => {
                  const here = inCell(row, col);
                  return (
                    <div className={`m-cell ${cellClass(row, col)}`} key={`${row}-${col}`}>
                      {here.map((r) => (
                        <span className="m-chip" key={r.id} title={r.name}>
                          {r.name.slice(0, 4)}
                        </span>
                      ))}
                    </div>
                  );
                })}
              </>
            ))}
          </div>
        </div>
      </div>

      <div className="matrix-legend">
        {[
          { cls: "mc-c", label: "Critical  (score > 15)" },
          { cls: "mc-h", label: "High  (9–15)"           },
          { cls: "mc-m", label: "Medium  (5–8)"          },
          { cls: "mc-l", label: "Low  (≤ 4)"             },
        ].map(({ cls, label }) => (
          <div className="ml-item" key={label}>
            <div className={`ml-sq ${cls}`} />
            {label}
          </div>
        ))}
      </div>
    </div>
  );
}